"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _color = _interopRequireDefault(require("color"));
var _Content = _interopRequireDefault(require("../Content"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Horizontal = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Horizontal() {
    var _this;
    _classCallCheck(this, Horizontal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Horizontal, [].concat(args));
    _defineProperty(_this, "state", {
      currentTab: _this.props.tabs[0].id
    });
    _defineProperty(_this, "setActiveTab", function (e, tabId) {
      e && e.preventDefault();
      _this.setState({
        currentTab: tabId
      });
    });
    return _this;
  }
  _inherits(Horizontal, _React$Component);
  return _createClass(Horizontal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        tabs = _this$props.tabs,
        displayOptions = _this$props.displayOptions;
      var tabContent;
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].id === this.state.currentTab) {
          var tab = tabs[i];
          tabContent = /*#__PURE__*/_react["default"].createElement(_Content["default"], {
            layout: tab.layout,
            text: tab.text,
            image: tab.image,
            video: tab.video,
            config: tab.config,
            displayOptions: displayOptions,
            key: tabs[i].id
          });
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12"
      }, tabs.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
        className: 'col-sm-' + (tabs.length * 3).toString() + ' col-sm-offset-' + (12 - tabs.length * 3).toString() + ' ' + _style["default"].tabs
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "nav nav-pills nav-justified"
      }, tabs.map(function (tab) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: tab.id,
          role: "presentation"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: _style["default"].navPill,
          onClick: function onClick(e) {
            return _this2.setActiveTab(e, tab.id);
          },
          href: "#",
          style: _this2.state.currentTab === tab.id ? {
            backgroundColor: (0, _color["default"])(displayOptions.portal.tabActiveColor).lighten(0.15),
            color: '#fff'
          } : {
            backgroundColor: displayOptions.portal.tabActiveColor,
            color: '#fff'
          }
        }, tab.name));
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        style: displayOptions && displayOptions.portal ? {
          borderTopColor: displayOptions.portal.infoBarAccentColor
        } : {},
        className: 'col-sm-12 ' + _style["default"].infoBar
      }, tabContent)));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Horizontal, "propTypes", {
  tabs: _propTypes["default"].array,
  displayOptions: _propTypes["default"].object
});